import "./jwplayer.css";

export default class JWPlayerAdapter {
  constructor(container, options = {}) {
    this.container = container;
    this.options = options;
    this.playlistSource = undefined;
    this.player = null;
  }

  // INITIALIZATION //

  loadScript = (script) =>
    new Promise((resolve, reject) => {
      // eslint-disable-next-line no-param-reassign
      script.onload = resolve;
      // eslint-disable-next-line no-param-reassign
      script.onerror = reject;
      document.body.appendChild(script);
    });

  createScript = () => {
    const script = document.createElement("script");
    script.src = `//content.jwplatform.com/libraries/VQrcBiHh.js`;
    script.crossOrigin = "anonymous";
    return script;
  };

  setup = async () => {
    if (!window.jwplayer) {
      await this.loadScript(this.createScript());
    }
    this.player = window.jwplayer(this.container);
    this.player.setup({
      playlist: `//content.jwplatform.com/v2/media/${this.options.source}`,
      related: {
        displayMode: "shelf",
        onclick: "link",
      },
      advertising: { client: "vast", tag: this.options.adTag },
      autostart: this.options.autostart,
    });

    this.player.on("mute", ({ mute }) => {
      this.options.mute = mute;
    });
    this.player.on("setupError", (e) => {
      Promise.reject(e);
    });
    this.player.on("error", (e) => {
      Promise.reject(e);
    });

    return Promise.resolve();
  };

  setSource = (source) => {
    this.options.source = source;
  };

  // CONFIGURATIONS //

  getSource = () => this.options.source;

  getState = () => this.player.getState();

  setPlaylist = (playlistSource) => {
    if (this.playlistSource !== playlistSource) {
      this.playlistSource = playlistSource;
      this.player.setPlaylistItemCallback((item) => {
        // eslint-disable-next-line no-param-reassign
        item.recommendations = `//content.jwplatform.com/v2/playlists/${playlistSource}`;
      });
    }
  };

  setAutostart = (autostart) => {
    this.options.autostart = autostart;
    setTimeout(() => {
      this.player.setConfig({ autostart });
    }, 0);
  };

  getAutostart = () => this.options.autostart;

  setMute = (mute) => {
    this.options.mute = mute;
    setTimeout(() => {
      this.player.setConfig({ mute });
    }, 0);
  };

  // PLAYBACK //
  play = () => {
    this.player.play();
  };

  pause = () => {
    this.player.pause();
  };

  load = (source) => {
    if (source !== this.options.source) {
      this.setSource(source);
      this.player.load(`//content.jwplatform.com/v2/media/${source}`);
    }
  };

  // EVENTS //
  onAdComplete = (callback = () => {}) => {
    this.player.on("adComplete", callback);
    return () => this.player.off("adComplete");
  };

  onAdStart = (callback = () => {}) => {
    this.player.on("adImpression", callback);
    return () => this.player.off("adImpression");
  };

  onDisplayClick = (callback = () => {}) => {
    this.player.on("displayClick", callback);
    return () => this.player.off("displayClick");
  };

  onTime = (callback = () => {}) => {
    this.player.on("time", callback);
    return () => this.player.off("time");
  };

  on = (event, callback) => this.player.on(event, callback);

  off = (event) => this.player.off(event);

  // CLEAR //
  remove = () => {
    if (this.player && this.player.remove) {
      this.player.remove();
    }
  };
}
